import { render, staticRenderFns } from "./EditLabelModal.vue?vue&type=template&id=f516136e&scoped=true&"
import script from "./EditLabelModal.vue?vue&type=script&lang=js&"
export * from "./EditLabelModal.vue?vue&type=script&lang=js&"
import style0 from "./EditLabelModal.vue?vue&type=style&index=0&id=f516136e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f516136e",
  null
  
)

export default component.exports